module.exports = __webpack_public_path__ + "img/logo_new.60f08074.png";